import App from './App.svelte';
import './i18n.js';

const app = new App({
	target: document.body,
});

export default app;